module.exports = __webpack_public_path__ + "fonts/356eda0.ttf";